<footer id="footer">
    <div class="container-fluid mt-5">
      <hr>
      <div class="row justify-content-center">
        <div class="col-lg-12">
          <div class="footer-top mt-5 flex-column">
            <h4 class="footer_name">NURUL HASSAN</h4>
            <div class="footer-logo">
              <h4>Follow Me</h4>
            </div>
            <div class="footer-social">
              <a href="https://www.facebook.com/nurulhassan2000"><i class="fa fa-facebook-square"></i></a>
              <a href="https://github.com/nurulhassan"><i class="fa fa-github-square"></i></a>
              <a href="https://behance.net/nurulhassan"><i class="fa fa-behance"></i></a>
              <a href="https://www.linkedin.com/in/isnurul"><i class="fa fa-linkedin-square"></i></a>
              <a href="https://wa.me/+919694691051"><i class="fa fa-whatsapp"></i></a>
            </div>
          </div>
        </div>
      </div>
      <div class="row footer-bottom justify-content-center mb-3">
        <p class="col-lg-8 col-sm-12 text-center footer-text">
          Copyright © 2019 | Developed with <i class="fa fa-heart p-0" aria-hidden="true"> </i> by <a routerLink="/" class="" target="_blank">Nurul Hassan</a>
        </p>
      </div>
    </div>
  </footer>